module.exports = __webpack_public_path__ + "img/bottom.09d4c771.svg";